import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  TextField,
  BooleanInput,
  BooleanField,
  FunctionField,
  EditButton,
  DateField,
  Resource,
  Show,
  SelectInput,
  Filter,
  ReferenceInput,
  Datagrid } from "react-admin";


const Filters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="name" alwaysOn />
    <TextInput label="Reference Year" source="referenceYear" />
    <TextInput label="Geography" source="geography" />
    <TextInput label="Primary Source" source="primarySource" />
  </Filter>
);

const CertificatesList = (props) => {
  return (
    <List {...props} filters={Filters(props)}>
      <div style={{marginTop: '15px'}}>
        <Datagrid rowClick="show">
          <TextField source="name" />
          <TextField source="id" />
          <TextField source="description" />
          <TextField source="referenceYear" />
          <TextField source="geography" />
          <TextField source="primarySource" />
          <TextField source="modelingSheet" />
          <TextField source="status" />
          <BooleanField source="sustained" label="Sustained" />
          <FunctionField
            source="sustained_justification"
            label="Sustained justification"
            render={(record) => record.sustained_justification && (
              <span
                title={record.sustained_justification}
                style={{ display: 'block', maxWidth: '280px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {record.sustained_justification}
              </span>
            )}
          />
          <TextField source="complete_name" label="Complete name" />
          <DateField source="createdAt" label="Creation date" />
          <DateField source="updatedAt" label="Update date" />
          <EditButton />
        </Datagrid>
      </div>
    </List>
  );
};

const ShowCertificates = (props) => {
  return (
    <Show {...props}>
      <SimpleForm>
        <TextField source="name" />
        <TextField source="id" />
        <TextField source="description" />
        <TextField source="referenceYear" />
        <TextField source="geography" />
        <TextField source="primarySource" />
        <TextField source="modelingSheet" />
        <TextField source="status" />
        <BooleanField source="sustained" label="Sustained" />
        <TextField source="sustained_justification" label="Sustained justification" emptyText="-" />
        <TextField source="complete_name" label="Complete name" emptyText="-" />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
      </SimpleForm>
    </Show>
  );
};

const CreateCertificates = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="name" />
        <ReferenceInput label="Category" source="categoryId" reference="evaluationCategory">
          <SelectInput source="name" />
        </ReferenceInput>
        <ReferenceInput label="Group" source="groupId" reference="evaluationGroup">
          <SelectInput source="name" />
        </ReferenceInput>
        <BooleanInput source="sustained" label="Sustained" />
        <TextInput source="sustained_justification" label="Sustained justification" multiline fullWidth />
        <TextInput source="complete_name" label="Complete name" fullWidth />
      </SimpleForm>
    </Create>
  );
};

const EditCertificates = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput source="name" />
        <ReferenceInput label="Category" source="categoryId" reference="evaluationCategory">
          <SelectInput source="name" />
        </ReferenceInput>
        <ReferenceInput label="Group" source="groupId" reference="evaluationGroup">
          <SelectInput source="name" />
        </ReferenceInput>
        <TextInput source="status" />
        <BooleanInput source="sustained" label="Sustained" />
        <TextInput source="sustained_justification" label="Sustained justification" multiline fullWidth />
        <TextInput source="complete_name" label="Complete name" fullWidth />
      </SimpleForm>
    </Edit>
  );
};


const certificatesResource = () => <Resource
  name="certificates"
  options={{ label: 'Certificates', menuGroup: 'Bcome'}}
  list={CertificatesList}
  create={CreateCertificates}
  edit={EditCertificates}
  show={ShowCertificates} />;

export default certificatesResource;
